export default "__VITE_ASSET__Cnaz$2_a__"